import { Anchor } from '@mantine/core'
import { useNavigate } from 'react-router-dom';

import classes from './index.module.css';

interface IFooterAnchor {
    text: string,
    href: string,
    white?: boolean,
    center?: boolean,
}

const FooterAnchor = ({ href, text, white, center }: IFooterAnchor) => {
    const navigate = useNavigate();

    return <Anchor onClick={() => navigate(href)} className={`${classes.anchor} ${white ? classes.white : ''} ${center ? classes.center : ''}`}>{text}</Anchor>
}

export default FooterAnchor;